__turbopack_context__.v({
  "homeCTAStrip": "home-cta-strip-module-scss-module__p8KRTG__homeCTAStrip",
  "homeCTAStripColumn": "home-cta-strip-module-scss-module__p8KRTG__homeCTAStripColumn",
  "homeCTAStripHeader": "home-cta-strip-module-scss-module__p8KRTG__homeCTAStripHeader",
  "homeCTAStripRow": "home-cta-strip-module-scss-module__p8KRTG__homeCTAStripRow",
});
